'use strict';

function mapToArray(map) {
  var arr = new Array(map.size), i = 0;
  map.forEach(function(val, key) {
    arr[i++] = [key, val];
  });
  return arr;
}

module.exports = mapToArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/mapToArray.js
// module id = 718
// module chunks = 0